import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Button } from './ui/Button';
export function AboutSection() {
  return <section className="py-24 bg-white" data-id="element-1">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-3">
          <div className="w-full lg:w-1/2" data-id="element-4">
            <div className="relative" data-id="element-5">
              <div className="absolute -top-4 -left-4 w-24 h-24 bg-secondary-light/30 rounded-full blur-xl" data-id="element-6" />
              <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-primary-light/20 rounded-full blur-xl" data-id="element-7" />
              <div className="relative bg-gradient-to-br from-neutral-50 to-white p-8 rounded-3xl border border-neutral-100 shadow-lg" data-id="element-8">
                <div className="aspect-[4/3] bg-neutral-200 rounded-2xl mb-6 overflow-hidden relative" data-id="element-9">
                  <div className="absolute inset-0 bg-coastal-gradient opacity-10" data-id="element-10"></div>
                  <div className="absolute inset-0 flex items-center justify-center text-primary/20" data-id="element-11">
                    <svg className="w-32 h-32" fill="currentColor" viewBox="0 0 24 24" data-id="element-12">
                      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" data-id="element-13" />
                    </svg>
                  </div>
                </div>
                <div className="flex items-center justify-between" data-id="element-14">
                  <div data-id="element-15">
                    <p className="font-heading font-bold text-xl text-primary-dark" data-id="element-16">
                      Neil Pereira
                    </p>
                    <p className="text-sm text-neutral-500" data-id="element-17">
                      Founder & Tax Preparer
                    </p>
                  </div>
                  <div className="text-right" data-id="element-18">
                    <p className="font-bold text-secondary-dark" data-id="element-19">
                      USC Marshall
                    </p>
                    <p className="text-xs text-neutral-400" data-id="element-20">Alumni</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-1/2" data-id="element-21">
            <h2 className="text-3xl md:text-4xl font-bold text-primary-dark mb-6" data-id="element-22">
              Expert Care, <br data-id="element-23" />
              <span className="text-secondary" data-id="element-24">Personal Touch.</span>
            </h2>

            <p className="text-lg text-neutral-600 mb-6 leading-relaxed" data-id="element-25">
              Coastal Ember was founded to bridge the gap between impersonal
              software and expensive accounting firms. We believe tax prep
              should feel like a concierge service—simple, transparent, and
              tailored to you.
            </p>

            <p className="text-lg text-neutral-600 mb-8 leading-relaxed" data-id="element-26">
              Run by a USC Marshall graduate, we ensure every return is prepared
              by a licensed CPA or Enrolled Agent (EA). You get the expertise of
              a professional firm with the friendly, modern approach of a
              trusted partner.
            </p>

            <ul className="space-y-4 mb-10" data-id="element-27">
              {['Licensed CPA or Enrolled Agent preparation', 'USC Marshall graduate leadership', 'Modern, digital-first experience', 'Concierge-level support'].map((item, i) => <li key={i} className="flex items-center text-neutral-700" data-id="element-28">
                  <CheckCircle2 className="w-5 h-5 text-secondary mr-3 flex-shrink-0" data-id="element-29" />
                  {item}
                </li>)}
            </ul>

            <Button onClick={() => document.getElementById('intake-form')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-30">
              Work With Us
            </Button>
          </div>
        </div>
      </div>
    </section>;
}